import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import ENV from "Constants/env";
import PageNotFound from "Containers/404";

import I18nService from "Services/i18n";
import onError from "Services/error";

import Layout from "Components/Layout";
import { ThemeProvider } from 'styled-components';
import store from "./store/configureStore";
import ErrorBoundary from "./Containers/ErrorBoundary";
import config from "./config";
import {notixPalette} from "./Constants/themes";
//    "styled-components": "5.3.6"
if (
  process.env.REACT_APP_NODE_ENV === ENV.PRODUCTION &&
  window.location.hostname !== config.testStg
) {
  window.onerror = onError;

  // Sentry.init({
  //   dsn: config.sentry,
  //   integrations: [new BrowserTracing()],
  //   tracesSampleRate: 1.0,
  // });
}

const defaultLanguage = I18nService.getDefaultLanguage();
I18nService.setDefaultLanguage(defaultLanguage)
  .then(() => I18nService.getStrings(defaultLanguage))
  .then(() => {
    ReactDOM.render(
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={notixPalette}>
            <ErrorBoundary>
              <Layout />
            </ErrorBoundary>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>,
      document.getElementById("app")
    );
  })
  .catch(() => {
    ReactDOM.render(<PageNotFound />, document.getElementById("app"));
  });
